import type { Input, Output } from '@iichi/schema-api-v2/endpoints/public/items/recently-viewed';

import axios from '@/js/lib/helper/axios';

export const get = async (params: Input): Promise<Output> => {
  const res = await axios.get<Output>('/api/v2/public/items/recently-viewed', {
    params,
  });
  return res.data;
};
